import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LKModal from '../Modal/Modal';

export default class InfoModalComponent extends PureComponent {
    static propTypes = {
        callback: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            showModal: true
        };
        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
    }
    close() {
        this.setState({ showModal: false }, () => {
            this.props.callback();
        });
    }
    open() {
        this.setState({ showModal: true });
    }
    render() {
        const { headerTitle, msgType, msgContent } = this.props;
        // msgType could be any one of the bootstrap alrert class: success, info, warning or danger
        return (
            <LKModal backdrop keyboard dialogClassName="infoModal" hideHandler={this.close} showModal={this.state.showModal} headerTitle={headerTitle}>
                <div className={`infoModal_msg alert margin-b0 fs16 alert-${msgType}`}>{msgContent}</div>
            </LKModal>
        );
    }
}
